export const ACCESS_MANAGEMENT_PATH = '/access_management';